import type { NocRef } from "@seagames/contracts";

/** A NOC as every board row shows it: the flag (decorative), the code in tabular figures, the country's name. */
export function NocLabel({ noc, showName = true, className = "" }: { noc: NocRef; showName?: boolean; className?: string }) {
	return (
		<span className={`inline-flex min-w-0 items-center gap-[0.5rem] ${className}`}>
			{noc.flag_url ? (
				<img src={noc.flag_url} alt="" className="h-[0.875rem] w-[1.3125rem] shrink-0 rounded-[2px] border border-rule object-cover" />
			) : (
				<span aria-hidden="true" className="h-[0.875rem] w-[1.3125rem] shrink-0 rounded-[2px] border border-rule bg-paper" />
			)}
			<span className="shrink-0 font-bold font-mono">{noc.code ?? "—"}</span>
			{showName && <span className="truncate font-normal">{noc.country_name ?? noc.name}</span>}
		</span>
	);
}
